import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { IGenericDefaultSelectOption, GenericDefaultSelectOption } from '../../../../models/generic'
import { ITicketParameter, TicketParameter } from '../../../../models/ticket'
import {TicketTypes, StateTypes, ActivityStatus, UserTemplate} from '../../../../common/enums'
import { namespace } from 'vuex-class'
import { SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYKEYS_FORCE } from '../../../../store/search'
import { SearchSortTypes, SearchEntities } from '../../../../common/enums/search-entities.enum'
import { BLOCK_MODULE_NAMESPACE, BLOCK_GET_BLOCKS_MASTER, BLOCK_GET_BLOCKS_AUTOCOMPLETE } from '../../../../store/block'
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store'
import { IUserDetails } from '../../../../models/user'
import { IBlockParameter, BlockParameter } from '../../../../models/block'
import {
  TICKET_MODULE_NAMESPACE,
  TICKET_LOADERS,
  TICKET_SET_LOADER_STATE,
  TICKET_GET_EQUIPMENT, TICKET_RESET_TICKETS, TICKET_RESET_FILTERS, TICKET_SET_PARAMETER
} from '../../../../store/ticket'
import {
  APARTMENT_MODULE_NAMESPACE,
  APARTMENT_GET_APPARTMENTS_MASTER,
  APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE,
  APARTMENT_SET_APPARTMENTS_MASTER, APARTMENT_SEARCH_ZONE
} from '../../../../store/apartment'
import { IApartmentParameter, ApartmentParameter, IApartmentListingViewModel } from '../../../../models/apartment'
import * as _ from "lodash"
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../../store/service-book'
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store'

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

const UPDATE_PARAM: string = 'update:param'
@Component({
  components: {
    'ticket-list-texts-loaders' : async () => import('../../loaders/ticket-list-texts-loader/TicketListTextsLoader.vue'),
    'ticket-list-filters-loaders' : async () => import('../../loaders/ticket-list-filters-loader/TicketListFiltersLoader.vue')
  }
})
class TicketListCondition extends Vue {
  dtTab: number
  dtTabs: string[]
  apartmentSearchParameter: IApartmentParameter
  dtDisplayLoaders: boolean
  dtZones: any[]

  get lblSetting () {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/generic-labels').default
    }
  }

  @Prop({ default: () => new TicketParameter, type: [Object] })
  param: ITicketParameter

  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails
  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>

  @SearchStore.Getter managers: any
  @BlockStore.Getter blocks: any[]
  @UserStore.Getter userInfo: IUserDetails
  @TicketStore.Getter characterProblems: { level_1: any[], level_2: any[] }
  @TicketStore.Getter loaders: Map<string,boolean>
  @ApartmentStore.Getter apartments: IApartmentListingViewModel[]
  @TicketStore.Getter ticketPriorityLevels: any[]
  @TicketStore.Getter equipments: any;
  @TicketStore.Getter ticketProblemType: any[]
  @TicketStore.Getter ticketParameter: ITicketParameter;

  @BlockStore.Action(BLOCK_GET_BLOCKS_MASTER)
  storeGetBlocks: (payload: { userInfo: IUserDetails, param?: any }) => Promise<any>
  @BlockStore.Action(BLOCK_GET_BLOCKS_AUTOCOMPLETE)
  storeGetBlocksAutocomplete: (param: IBlockParameter) => Promise<any>
  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetManagers: (payload?: { keys: SearchEntities[] } ) => Promise<any>
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_MASTER)
  storeGetApartments: (param: IApartmentParameter) => void
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (param: { blockId: number | number[], key: string }) => Promise<any>
  @TicketStore.Action(TICKET_GET_EQUIPMENT)
  storeGetEquipments: (params: any) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_SEARCH_ZONE)
  storeSearchApt: (payload: { apartments: number[], q: string }) => Promise<any>;

  @TicketStore.Mutation(TICKET_SET_LOADER_STATE)
  storeSetLoaderState: (payload:{ key: string, value: boolean }) => void
  @ApartmentStore.Mutation(APARTMENT_SET_APPARTMENTS_MASTER)
  storeSetApartments:(payload:any) => void
  @TicketStore.Mutation(TICKET_RESET_FILTERS)
  storeResetFilterTicket: () => void;
  @TicketStore.Mutation(TICKET_SET_PARAMETER)
  storeSetTicketParameter: (param: ITicketParameter) => void;

  /**
   *
   */
  constructor () {
    super()
    this.dtTab = null
    this.dtTabs = [
      'basicSearch', 'advancedSearch'
    ]

    this.apartmentSearchParameter = new ApartmentParameter({
      $limit: 50
    })

    this.dtDisplayLoaders= false
  }

  get isServiceBookUser():boolean {
    return this.userInfo.template !== UserTemplate.default
  }

  get coNaturalOfProblemOptions (): IGenericDefaultSelectOption<number>[] {
    return (this.characterProblems.level_1 || []).map(x => ({ value: x.id, text: x.name }))
  }
  get coEquipmentOptions (): IGenericDefaultSelectOption<number>[] {
    return (this.equipments || []).map(x => ({ value: x.id, text: x.reference ? `(${x.reference}) ${x.name}` : x.name }))
  }
  get coZoneOptions (): IGenericDefaultSelectOption<number>[] {
    return (this.dtZones || []).map(x => ({ value: x.id, text: x.name }))
  }
  get coTicketPriorityLevels (): IGenericDefaultSelectOption<number>[] {
    return (this.ticketPriorityLevels || []).map(x => ({ value: x.id, text: x.name }))
  }
  get coTypeofProblemOptions (): IGenericDefaultSelectOption<string>[] {
    let types = this.ticketProblemType;
    if (!this.$route.meta.filter_by_problem_type_internal) {
      types =  types.filter(x => (x.key !== TicketTypes.Internal))
    }
    return (types || []).map(x => ({ value: x.key, text: x.name }))
  }
  get coStates (): IGenericDefaultSelectOption<string>[] {
    return [
      StateTypes.Open,
      StateTypes.InProgress,
      StateTypes.ReOpen,
      StateTypes.Close
    ].map(type => new GenericDefaultSelectOption<string>(this.$t(this.lblSetting.lblState[type]).toString(), type))
  }

  get coBlocks () {
    console.log('filters blocks',this.blocks)
    return this.blocks.map(b => {
      return { value: b.id, text: b.name }
    })
  }



  get coApartments () {
     if (this.fKTicketBlock && this.fKTicketBlock.length) {
      return _.filter(this.apartments || [],
        x => _.includes(this.fKTicketBlock, x.block.id)
      ).map(x => {
        return {
          value: x.id,
          text: x.location_number ? x.location_number + ' / ' + x.apartment_number : x['apartment_number']
        }
      })
    } else {
       console.log('apaaaartments=',this.apartments)
       return (this.apartments || []).map(x => {
       return {
         value: x.id,
         text: x['location_number'] ? x['location_number'] + ' / ' + x['apartment_number'] : x['apartment_number']
       }
     })
    }
  }
  get coManagers () {
    return (this.managers || []).map(manager => {
      return { value: manager.id, text: `${manager.firstname} ${manager.lastname}` }
    })
  }

  get coSortTypes (): IGenericDefaultSelectOption<number>[] {
    return [SearchSortTypes.MoreRecent,
      SearchSortTypes.Older].map(val => new GenericDefaultSelectOption<number>(this.$t(this.lblSetting.lblSort[`lblSortType${val}`]).toString(), val))
  }
  get blockSearchParameter () {
    return {
      userInfo: this.userInfo,
      param: new BlockParameter
    }
  }

  get coLoaders(){
    return this.loaders.get(TICKET_LOADERS.LIST_FILTERS)
  }

  get hasApartment () {
    if (Array.isArray(this.fKTicketApartment))
      return this.fKTicketApartment.length > 0
    return this.fKTicketApartment
  }

  get isServiceBook():boolean {
    if(this.$route.path.includes('service-book'))
    {
      return true
    }
    return false
  }



  created () {
    this.storeGetManagers({ keys: [SearchEntities.Manager] }).catch(error => console.log(error))
    if(this.$route.path.includes('service-book'))
    {
      if(!this.currentServiceBook.apartment)
      {
        const id = this.$route.params.id
        this.storeGetServiceBook(id).then(()=>{
          this.fKTicketBlock = [parseInt(this.currentServiceBook.apartment.fk_apartment_block)]
          this.fKTicketApartment = this.currentServiceBook.apartment.id
          this.storeGetEquipments({
            $limit: 20,
            block: this.fKTicketBlock,
            apartment:this.fKTicketApartment
          })
        })
      } else {
        this.fKTicketBlock = [parseInt(this.currentServiceBook.apartment.fk_apartment_block)]
        this.fKTicketApartment = this.currentServiceBook.apartment.id
        this.storeGetEquipments({
          $limit: 20,
          block: this.fKTicketBlock,
          apartment:this.fKTicketApartment
        })
      }
    }
  }

  get fKTicketBlock (): number[] {
    return this.param.block
  }
  set fKTicketBlock (val: number[]) {
    this.handleEmitParam({ block: val })
  }

  get fKTicketApartment (): number[] | number {
    console.log("apartment param=",this.param.apartment)
    return this.param.apartment
  }
  set fKTicketApartment (val: number[] | number) {
    this.handleEmitParam({ apartment: val })
  }
  get fKTicketState (): string[] | number[] {
    return this.param.state
  }
  set fKTicketState(val: string[] | number[]) {
    this.handleEmitParam({ state: val })
  }
  get pbType (): string[] {
    return this.param.pb_type
  }
  set pbType (val: string[]) {
    this.handleEmitParam({ pb_type: val })
  }
  get fkTicketCharacterProblem (): number[] {
    return this.param.fk_ticket_character_problem
  }
  set fkTicketCharacterProblem (val: number[]) {
    this.handleEmitParam({ fk_ticket_character_problem: val })
  }
  get fkTicketEquipment (): number[] {
    return this.param.equipment
  }
  set fkTicketEquipment (val: number[]) {
    this.handleEmitParam({ equipment: val })
  }
  get paramZone (): number[] {
    return this.param.apartmentZone
  }
  set paramZone (val: number[]) {
    this.handleEmitParam({ apartmentZone: val })
  }

  get fkTicketPriorityLevel (): number[] {
    return this.param.priority
  }
  set fkTicketPriorityLevel (val: number[]) {
    this.handleEmitParam({ priority: val })
  }
  get actors (): number[] {
    return this.param.actors
  }
  set actors (val: number[]) {
    this.handleEmitParam({ actors: val })
  }

  get sortValues (): number[] {
    return this.param.orderValues
  }
  set sortValues (val: number[]) {
    this.handleEmitParam({ orderValues: val })

  }
  get visibility (): "self" | "park" | "agency" | null {
    return this.param.visibility
  }
  set visibility (val: "self" | "park" | "agency" | null) {
    this.handleEmitParam({ visibility: val })
  }

  handleEmitParam (param: any) {
    this.$emit(UPDATE_PARAM, { ...this.param, ...param, $skip: 0 })
  }
  get viewVisibilities (): { text: any, value: any }[] {
    const visibilities: any = []
    if (this.$route.meta.filter_ticket_self) {
      visibilities.push({ text: this.$t(this.lblSetting.ticketVisibilitySelf), value: "self" })
    }
    if (this.$route.meta.filter_ticket_park) {
      visibilities.push(
        { text: this.$t(this.lblSetting.ticketVisibilityPark), value: "park" })
    }
    if (this.$route.meta.filter_ticket_agency) {
      visibilities.push(
        { text: this.$t(this.lblSetting.ticketVisibilityAgency), value: "agency" })
    }
    return visibilities
  }
  handleRemoteFetch (key: string, cb: Function, loading: Function) {
    this.dtDisplayLoaders= true
    this.storeGetBlocksAutocomplete({ key })
      .then(res => {
        cb((res || []).map(x => ({ value: x.id, text: x.name })))
        loading && loading(false)
        this.dtDisplayLoaders= false
      })
      .catch(error => console.log(error))
  }

  handleApartmentRemoteFetch (key: string, cb: Function, loading: Function) {
    const param: any = { key: key }

    if (this.fKTicketBlock) {
      param.blockId = this.fKTicketBlock
    }

    this.storeGetApartmentsAutocomplete(param)
      .then(res => {
        cb((res || []).map(x => ({
          value: x.id, text: x.apartment_number
        })))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  handleZoneRemoteFetch (q: string, cb: Function, loading: Function) {
    const payload: any = {apartments: this.fKTicketApartment, q}
    this.storeSearchApt(payload)
      .then(res => {
        cb((res.data || []).map(x => ({value: x.id, text: x.name, ...x})))
        loading && loading(false)
      })
      .catch(error => console.log(error))
  }

  onChangeBlock () {
    this.$nextTick(() => {
      this.fillApartmentList()
      this.getEquipmentByParams()
    })
  }

  onChangeApartment () {
    this.$nextTick(() => {
      this.getEquipmentByParams()
      this.handleFillZone()
    })
  }

  onChangeZone () {}

  onChangeCharPb () {
    this.$nextTick(() => {
      this.getEquipmentByParams()
    })
  }

  fillApartmentList () {
    this.$nextTick(() => {
      this.storeGetApartmentsAutocomplete({blockId: this.fKTicketBlock, key: ''})
        .then(res => {
          this.fKTicketApartment = []
          this.storeSetApartments({
            activityStatus: ActivityStatus.Loaded,
            apartments: res
          })
        })
    })
  }

  handleFillZone () {
    if (this.hasApartment && this.$route.meta.apartment_zone_allowed) {
      let apt = Array.isArray(this.fKTicketApartment) ? this.fKTicketApartment : [this.fKTicketApartment]
      let payload = {apartments: apt, q: ''}
      this.storeSearchApt(payload)
        .then(res => {
          this.dtZones = res.data
        })
        .catch(error => console.log(error))
    } else {
      this.paramZone = []
      this.dtZones = []
    }
  }

  setFilterLoaderState(value: boolean){
    this.storeSetLoaderState({ key: TICKET_LOADERS.LIST_FILTERS , value })
  }



  getEquipmentByParams(resetEqp= true) {
    let params: any = {
      $limit: 1000,
      block: this.fKTicketBlock
    }
    if (this.fKTicketApartment)
      params.apartment = this.fKTicketApartment
    if (this.fkTicketCharacterProblem)
      params.char1 = this.fkTicketCharacterProblem
    if (resetEqp) {
      this.fkTicketEquipment = []
    }
    if (this.$route.meta.filter_by_equipment) {
      this.storeGetEquipments(params)
    }
  }

  resetFilter () {
    this.storeResetFilterTicket()
    if (this.$route.meta.filter_ticket_agency) {
      this.storeSetTicketParameter({
        ...this.ticketParameter,
        visibility: 'agency',
      })
    }
    if(this.$route.path.includes('service-book'))
    {
      this.storeSetTicketParameter({
        ...this.ticketParameter,
        apartment: this.currentServiceBook.apartment.id
      })
    }
  }
}

export default TicketListCondition



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-list-conditions/index.ts